export default __webpack_public_path__ + "static/media/closeIcon.2d3ab14d.svg";